import { Marker, Tooltip } from "react-leaflet";
import L from "leaflet";

const icon = (level) =>
  L.divIcon({
    className: "",
    iconSize: [18, 18],
    iconAnchor: [9, 9],
    html: `<div class="atlas-dam ${level ? `atlas-dam-${level}` : ""}"></div>`,
  });

const pct = (v) => `${Math.round((v || 0) * 100)}%`;

// Sentinel-1 landslide-dam watch corridors: hollow = monitored, filled = blockage detected.
export const DamLayer = ({ corridors = [] }) =>
  corridors.map((c) => (
    <Marker key={c.name} position={[c.lat, c.lon]} icon={icon(c.level)}>
      <Tooltip direction="top" offset={[0, -8]} className="atlas-tip" opacity={1}>
        <b>{c.level ? `RIVER BLOCKAGE ${c.level.toUpperCase()}` : "LANDSLIDE-DAM WATCH"}</b>
        <br />
        {c.name}, {c.country}
        <br />
        <span className="atlas-tip-muted">
          {c.now_date
            ? `Sentinel-1 ${c.ref_date} → ${c.now_date} · new water ${c.result?.lake_km2 ?? 0} km² · channel lost ${pct(c.result?.channel_loss)}`
            : "Awaiting first Sentinel-1 comparison"}
        </span>
      </Tooltip>
    </Marker>
  ));
